<script setup>

import FileManagerList from "@/components/files/preview/FileManagerList.vue";
import FileManagerGallery from "@/components/files/preview/FileManagerGallery.vue";

const props = defineProps({
  preview: {
    validator: value => ['none', 'list', 'gallery'].includes(value),
  },
  files: {
    type: Array,
    default: () => []
  },
  fileUrl: {
    type: Function,
    required: true,
  },
  currentId: {
    type: Number
  },
})

const emit = defineEmits(['delete:file'])

</script>

<template>
  <file-manager-gallery
      v-if="props.preview === 'gallery'"
      :files="props.files"
      :file-url="props.fileUrl"
      class="mb-5"
      :current-id="props.currentId"
      @delete:file="args => emit('delete:file', args)"
  />
  <file-manager-list
      v-if="props.preview === 'list'"
      :files="props.files"
      :file-url="props.fileUrl"
      class="mb-5"
      @delete:file="args => emit('delete:file', args)"
  />
</template>

<style scoped>

</style>